/**
 * Safe wrapper para localStorage com tratamento de erros
 * Previne falhas em modo privado/incognito e QuotaExceededError
 */
export const safeLocalStorage = {
  /**
   * Salva um item no localStorage de forma segura
   * @param {string} key - Chave do item
   * @param {string} value - Valor a ser salvo
   * @returns {boolean} - true se salvou com sucesso, false caso contrário
   */
  setItem(key, value) {
    try {
      if (typeof key !== 'string' || !key) {
        console.error('safeLocalStorage.setItem: Invalid key');
        return false;
      }
      localStorage.setItem(key, String(value));
      return true;
    } catch (error) {
      console.error('safeLocalStorage.setItem failed:', error);
      // Fallback: poderia usar sessionStorage ou memória
      return false;
    }
  },

  /**
   * Recupera um item do localStorage de forma segura
   * @param {string} key - Chave do item
   * @returns {string|null} - Valor recuperado ou null
   */
  getItem(key) {
    try {
      if (typeof key !== 'string' || !key) {
        console.error('safeLocalStorage.getItem: Invalid key');
        return null;
      }
      return localStorage.getItem(key);
    } catch (error) {
      console.error('safeLocalStorage.getItem failed:', error);
      return null;
    }
  },

  /**
   * Remove um item do localStorage de forma segura
   * @param {string} key - Chave do item
   * @returns {boolean} - true se removeu com sucesso, false caso contrário
   */
  removeItem(key) {
    try {
      if (typeof key !== 'string' || !key) {
        console.error('safeLocalStorage.removeItem: Invalid key');
        return false;
      }
      localStorage.removeItem(key);
      return true;
    } catch (error) {
      console.error('safeLocalStorage.removeItem failed:', error);
      return false;
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/storage.js